import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLegalDocuments = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#ff897e",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "DocumentType",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Legal documents",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "Rectangle 16660",
				d: "M2.5 0.5H10.3789C10.644 0.50006 10.8985 0.605486 11.0859 0.792969L14.207 3.91406C14.3945 4.10155 14.4999 4.35596 14.5 4.62109V14.5C14.5 15.0523 14.0523 15.5 13.5 15.5H2.5C1.94772 15.5 1.5 15.0523 1.5 14.5V1.5C1.5 0.947715 1.94772 0.5 2.5 0.5Z",
				fill: "currentColor",
				fillOpacity: .25,
				stroke: "currentColor"
			}), /* @__PURE__ */ _jsxs("g", {
				id: "Group",
				children: [/* @__PURE__ */ _jsx("path", {
					id: "Vector",
					d: "M7.91659 6.80817L3.58754 10.8867C3.47392 11.0006 3.41012 11.1549 3.41012 11.3159C3.41012 11.4768 3.47392 11.6311 3.58754 11.745L4.01905 12.1766C4.13299 12.2902 4.28734 12.354 4.44825 12.354C4.60916 12.354 4.7635 12.2902 4.87744 12.1766L8.95593 7.84751",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}), /* @__PURE__ */ _jsx("path", {
					id: "Vector_2",
					d: "M12.4123 6.78962C10.9675 5.98731 9.77642 4.79623 8.97412 3.35143C8.86018 3.23781 8.70583 3.17401 8.54492 3.17401C8.38401 3.17401 8.22967 3.23781 8.11573 3.35143L6.48712 4.98005C6.37321 5.09478 6.30929 5.24989 6.30929 5.41156C6.30929 5.57323 6.37321 5.72834 6.48712 5.84307C7.94664 6.62357 9.14283 7.81815 9.9253 9.27662C10.0392 9.39024 10.1936 9.45404 10.3545 9.45404C10.5154 9.45404 10.6697 9.39024 10.7837 9.27662L12.4123 7.648C12.5259 7.53406 12.5897 7.37972 12.5897 7.21881C12.5897 7.0579 12.5259 6.90356 12.4123 6.78962Z",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})]
			})]
		})
	})
});
export default SvgLegalDocuments;
